var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"scroll-animate",class:{ 'is-visible': _vm.isVisible },style:({
    transitionDelay: _vm.delay + 'ms',
    transitionDuration: _vm.duration + 'ms'
  })},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }